<!--
  print-fallback-banner.component.html
  The standing notice that printing is being routed around dead hardware, plus
  the one-tap way out of it. role="status" so it is announced when it appears
  without stealing focus from whatever the user is in the middle of.
-->

<div class="print-fallback-banner" *ngIf="isVisible" role="status" aria-live="polite">

  <ion-icon class="print-fallback-icon" name="print-outline" aria-hidden="true"></ion-icon>

  <div class="print-fallback-text">
    <span class="print-fallback-title">{{ title }}</span>
    <!-- Where the printing is actually going — the part that keeps someone from
         standing at a printer waiting for output that went to a browser dialog. -->
    <span class="print-fallback-detail">{{ detail }}</span>
  </div>

  <!-- No dismiss: this reports a state only a person can end, so the only
       control is the one that ends it. -->
  <ion-button
    class="print-fallback-btn"
    fill="clear"
    size="small"
    (click)="onTurnOff()">
    Turn off
  </ion-button>

</div>
